import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconTheaterComedy = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconTheaterComedy",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M280-80q-100 0-170-70T40-320v-200q0-33 24-56t56-24h320q33 0 57 24t23 56v200q0 100-70 170T280-80m-80-300q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11m160 0q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11m560-420v200q0 100-70 170t-170 70q-18 0-35-2t-35-8q-14-5-22-17t-8-27v-126q0-47-29-82t-74-35q-16 0-26-11t-11-29v-103q0-33 24-56t56-24h320q33 0 57 24t23 56M600-660q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11m160 0q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11m-80 60q-29 0-55 12t-39 37q-5 10 3 19t19 8h144q12 0 20-8t2-19q-12-26-38-37t-56-12M280-244q28 0 53-11t39-35q6-10 0-20t-18-10H206q-12 0-18 10t0 20q14 24 39 35t53 11"
  })
}));
IconTheaterComedy.displayName = 'IconTheaterComedy';